import React from 'react';
import useApiPost from './useApiPost';
import { isActiveFeature } from '../utils/helpers.js';
import useSelectedTemplateId from '../store/selectors/useSelectedTemplateId';

const buildFormData = ({ uId, bId, templateId, selectedVideo, selectedContacts, selectedDetails, dateTime, timeZone, selectedPrograms, selectedDocuments, selectedImages }) => {
  let formData = new FormData();
  dateTime = new Date((typeof dateTime === "string" ? new Date(dateTime) : dateTime).toLocaleString("en-US", {timeZone: timeZone}));
  dateTime = Math.round(dateTime.getTime()/1000);

  formData.set('hID', 'sendEmailTemplate');
  formData.set('uID', uId);
  formData.set('bID', bId);
  formData.set('vID', selectedVideo);
  formData.set('tID', templateId);
  formData.set('type', selectedDetails.type);
  formData.set('recipients', JSON.stringify(selectedContacts));
  formData.set('details', JSON.stringify(selectedDetails));
  formData.set('programs', JSON.stringify(selectedPrograms));
  formData.set('files', JSON.stringify(selectedDocuments));
  formData.set('images', JSON.stringify(selectedImages));
  formData.set('smsEnabled', isActiveFeature('sms_sends') ? 1 : 0);
  formData.set('timeToSend', dateTime);

  return formData;
};

export default function useScheduleEmail() {
  const { loading, handlePost } = useApiPost();
  const [{ disableSchedule }, setState] = React.useState({ disableSchedule: false });
  const templateId = useSelectedTemplateId();
  const scheduleEmail = React.useCallback(
    ({ uId, bId, selectedVideo, selectedContacts, selectedDetails, dateTime, timeZone, selectedPrograms, selectedDocuments, selectedImages, ...other }) => {
      handlePost({
        data: buildFormData({ uId, bId, templateId, selectedVideo, selectedContacts, selectedDetails, dateTime, timeZone, selectedPrograms, selectedDocuments, selectedImages }),
        onError: () => {
          console.error('Error scheduling email');
          setState(prev => ({ ...prev, disableSchedule: true }));
        },
        ...other
      });
    },
    [handlePost, templateId]
  );

  return { schedulingEmail: loading, scheduleEmail, disableSchedule };
}
